
// 引用公共js 20190812
import { getTime } from '../../../assets/js/xjpublic'
// 引入组件
import { Cell, CellGroup, ActionSheet, Popup, DatetimePicker } from 'vant'

export default {
  name: 'home',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  data () {
    return {
      // queryType为1是查询照片,为2是查询视频
      queryType: 1,
      // 请求参数
      nowImei: $cookies.get('imei'),
      cameraType: '前置摄像头',
      cameraTypeValue: 1,
      startTime: '',
      // 获取当天0点的时间
      // 方法一：OPPO手机解析不出
      // startTimeDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
      // 方法二: OPPO手机解析不出
      // startTimeDate: new Date(new Date().toLocaleDateString()),
      // 方法三: ios系统解析不出
      // startTimeDate: new Date(getTime.getFormatDate(1) + ' ' + '00:00:00'),
      // 方法四：
      // startTimeDate: new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000).setHours(0,0,0,0)),
      startTimeDate: new Date(new Date(new Date().getTime()).setHours(0,0,0,0)),
      endTime: '',
      endTimeDate: new Date(),
      pictureType: '实时拍照',
      pictureTypeValue: 7,
      // 下拉选择
      showActionSheetCamera: false,
      cameraTypeList: [
        { name: '前置摄像头', value: 1 },
        { name: '后置摄像头', value: 2 },
        { name: '前+后摄像头', value: 3 },
        { name: '全景摄像头', value: 4 }
      ],
      showActionSheetPicture: false,
      pictureTypeList: [],
      pictureTypeListPhoto: [
        { name: '实时拍照', value: 7 },
        { name: '语音拍照', value: 3 },
        { name: '停车报警拍照', value: 11 },
        { name: '行车碰撞拍照', value: "5,16" },
        { name: '按键拍照', value: 21 },
        // { name: '全部', value: -1 },
      ],
      pictureTypeListVideo: [
        { name: '实时视频', value: 8 },
        { name: '语音视频', value: 4 },
        { name: '停车报警视频', value: '6,5' },
        { name: '行车碰撞视频', value: 6 },
        { name: '按键视频', value: 22 },
        { name: '紧急视频', value: 14 },
        // { name: '全部', value: -2 },
      ],
      // 时间选择
      showPopupStartTime: false,
      currentDate: new Date(),
      minDate: new Date('2017-01-01'),
      maxDate: new Date(),
      showPopupEndTime: false
    }
  },
  methods: {
    // 选择摄像头
    selectCameraFn () {
      this.showActionSheetCamera = true;
    },
    onSelectCameraFn (item) {
      this.cameraType = item.name;
      this.cameraTypeValue = item.value;
      this.showActionSheetCamera = false;
    },
    // 选择照片类型
    selectPictureFn () {
      this.showActionSheetPicture = true;
    },
    onSelectPictureFn (item) {
      this.pictureType = item.name;
      this.pictureTypeValue = item.value;
      this.showActionSheetPicture = false;
    },
    // 选择开始日期
    selectStartTimeFn () {
      this.currentDate = new Date(this.startTime);
      this.showPopupStartTime = true;
    },
    onSelectStartTimeFn (value) {
      this.startTime = getTime.getFormatDate(1, value);
      this.startTimeDate = value;
      this.showPopupStartTime = false;
    },
    // 选择结束日期
    selectEndTimeFn () {
      this.currentDate = new Date(this.endTime);
      this.showPopupEndTime = true;
    },
    onSelectEndTimeFn (value) {
      this.endTime = getTime.getFormatDate(1, value);
      // this.endTimeDate = value;
      // 方法一：结束时间在选择的基础上加一天(这个方法会出现再次弹出选择下拉时也会显示多一天)
      // this.endTimeDate = new Date(new Date(value).valueOf() + 1000 * 60 * 60 * 24);
      // 方法二：结束时间最后变成选择的日期的23:59:59
      this.endTimeDate = new Date(new Date(value).valueOf() + 60000 * 60 * 24 - 1);
      this.showPopupEndTime = false;
    },
    onclosePopupFn () {
      this.showPopupStartTime = false;
      this.showPopupEndTime = false;
    },
    // 查询检查日期间隔
    queryCheckFn () {
      let startTimeStamp = new Date(this.startTimeDate).valueOf();
      let endTimeStamp = new Date(this.endTimeDate).valueOf();
      if (startTimeStamp > endTimeStamp) {
        this.$dialog({
          message: '结束日期不能小于开始日期'
        });
        return
      }
      if (endTimeStamp - startTimeStamp > 60000 * 60 * 24 * 5) {
        this.$dialog({
          message: '查询的日期间隔不能超过5天'
        });
        return
      }
      this.querySubmitFn();
    },
    // 查询提交
    querySubmitFn () {
      // localStorage 保存用户的查询条件
      localStorage.setItem('xjWxQueryMediaCamera', this.cameraTypeValue);
      localStorage.setItem('xjWxQueryMediaStartTime', this.startTime);
      localStorage.setItem('xjWxQueryMediaEndTime', this.endTime);
      localStorage.setItem('xjWxQueryMediaPictureType', this.pictureTypeValue);
      // 查询
      this.$router.push('/photoList?type=' + this.pictureTypeValue + '&camera=' + this.cameraTypeValue + '&startTime=' + this.startTimeDate + '&endTime=' + this.endTimeDate)
    },
    // 跳转到首页
    toHomePageFn () {
      this.$router.push('/')
    },
    // 切换设备
    toChangeDevPageFn () {
      this.$router.push('/changeDev')
    }
  },
  mounted () {
    // 获取页面传参,queryType为1是查询照片,为2是查询视频
    let queryType = parseInt(this.$route.query.type);
    this.queryType = queryType || 1;
    this.pictureTypeList = queryType === 1 ? this.pictureTypeListPhoto : this.pictureTypeListVideo;
    this.pictureType = queryType === 1 ? '实时拍照' : '实时视频';
    this.pictureTypeValue = queryType === 1 ? 7 : 8;
    this.startTime = getTime.getFormatDate(1);
    this.endTime = getTime.getFormatDate(1);
    // localStorage 获取本地存储(用户上次的查询条件)
    if (localStorage.getItem('xjWxQueryMediaCamera')) {
      this.cameraTypeValue = parseInt(localStorage.getItem('xjWxQueryMediaCamera'));
      const selectCameraFn = this.cameraTypeList.find(item=>item.value == this.cameraTypeValue)
      this.cameraType = selectCameraFn.name || "前置摄像头"
    }
    if (localStorage.getItem('xjWxQueryMediaPictureType')) {
      this.pictureTypeValue = localStorage.getItem('xjWxQueryMediaPictureType');
      const selectCameraFn = this.pictureTypeList.find(item=>item.value == this.pictureTypeValue)
      this.pictureType = selectCameraFn.name || this.pictureType

    }
    if (localStorage.getItem('xjWxQueryMediaStartTime')) {
      this.startTime = localStorage.getItem('xjWxQueryMediaStartTime');
      this.startTimeDate = new Date(new Date(new Date(this.startTime).getTime()).setHours(0,0,0,0));
    }
    if (localStorage.getItem('xjWxQueryMediaEndTime')) {
      this.endTime = localStorage.getItem('xjWxQueryMediaEndTime');
      this.endTimeDate = new Date(new Date(this.endTime).valueOf() + 1000 * 60 * 60 * 24 - 1000 * 60 * 60 * 8 - 1000);
    }
    // localStorage 删除本地存储(用户的查询条件)(放在TakePicture页面和TakeVideo页面)
    // localStorage.removeItem('xjWxQueryMediaStartTime');
    // localStorage.removeItem('xjWxQueryMediaEndTime');
    // localStorage.removeItem('xjWxQueryMediaCamera');
    // localStorage.removeItem('xjWxQueryMediaPictureType');
  }
}
